import { GiReceiveMoney, GiRemedy } from "react-icons/gi";
import { HiOutlineCash, HiOutlineUser } from "react-icons/hi";
import { IoCalendar } from "react-icons/io5";
import { Button } from "../../components/ui/Button";
import { FcAssistant } from "react-icons/fc";

export const WhatIsFamilyLifeInsurance = ({ onGoToRegister }) => (
    <div className="w-full">
        <section id="WhatIsFamilyLifeInsurance" className="bg-white py-16 px-6 max-w-7xl mx-auto text-center">
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                Seguro Vida Familiar
            </span>

            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 max-w-xl mx-auto leading-relaxed mb-4">
                O que é o Seguro Vida Familiar?
            </h2>

            <p className="text-gray-600 max-w-xl mx-auto mb-12 leading-relaxed">
                O Seguro Vida Familiar foi criado para proporcionar segurança e assistência para você e sua família nos momentos de necessidade. Além das coberturas financeiras essenciais, como morte e invalidez, oferece diversos benefícios desde o primeiro dia, como remédios grátis, assistência funeral e sorteios de R$ 15 mil todos os meses.
            </p>
            <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                Vantagens
            </span>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-12 text-left">
                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <GiRemedy className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Remédio Grátis</h3>
                    <p className="text-gray-600 text-sm">
                        Tenha acesso a remédio grátis ilimitados* após consultas emergenciais para você e até 3 familiares.
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <FcAssistant className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Assistência Funeral</h3>
                    <p className="text-gray-600 text-sm">
                        Tenha apoio nos momentos mais difíceis, com orientações e assistência funeral para o titular e até 3 familiares.
                    </p>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                    <GiReceiveMoney className="text-orange-500 w-6 h-6 mb-2" />
                    <h3 className="font-semibold text-gray-800 mb-1">Compra de Medicamentos</h3>
                    <p className="text-gray-600 text-sm">
                        Até R$ 300 em medicamentos receitados após consultas agendadas para você e até 3 familiares.
                    </p>
                </div>
            </div>

            <Button onClick={onGoToRegister} variant="outline">
                Contratar agora
            </Button>
        </section>
    </div>
)